import React from "react";
const CodeBlockIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "13", viewBox: "0 0 18 13", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M10.917 4l.968.25-3.108 12-.969-.25 3.109-12zM5.528 5.253l.732.682-3.893 4.18 3.893 4.178-.732.682L1 10.115l4.528-4.862zm8.62 0l4.553 4.862-4.553 4.86-.73-.684 3.912-4.176-3.912-4.178.73-.684z",
    transform: "translate(-345.000000, -81.000000) translate(344.000000, 77.000000)"
  }
)))));
var CodeBlockIcon_default = CodeBlockIcon;
export {
  CodeBlockIcon_default as default
};
//# sourceMappingURL=CodeBlockIcon.js.map
